var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-container"},[_c('van-button',{on:{"click":_vm.pay}},[_vm._v("支付")]),_c('van-button',{on:{"click":_vm.uploadGameRole}},[_vm._v("上报角色")]),_c('van-button',{on:{"click":_vm.repeatLogin}},[_vm._v("登录被顶")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }